import { render, staticRenderFns } from "./TheDarkHeader.vue?vue&type=template&id=776597b7&"
import script from "./TheDarkHeader.vue?vue&type=script&lang=js&"
export * from "./TheDarkHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheDarkHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports